<template>
  <v-card>
    <v-card-title>
      <span class="text-h5">{{ title }}</span>
    </v-card-title>

    <v-card-text>
      <v-container>
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-if="staff"
              v-model="name"
              disabled
            />
            <s-search-staff
              v-if="!staff"
              show-support-staff
              :select.sync="euid"
              :label="$t('PublicServant.Staff')"
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="3"
          >
            <s-date-picker
              v-model="startDate"
              :label="$t('eLeave.StartDate')"
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="3"
          >
            <s-date-picker
              v-model="endDate"
              :label="$t('eLeave.EndDate')"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <v-card-actions>
      <div class="flex-grow-1" />
      <v-btn
        color="blue darken-1"
        text
        @click="close"
      >
        {{ $t('Text.Cancel') }}
      </v-btn>
      <v-btn
        color="blue darken-1"
        text
        @click="save"
      >
        {{ $t('PublicServant.Action.Save') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import SSearchStaff from '@/components/SSearchStaff'
import SDatePicker from '@/components/SDatePicker'
import workflowApi from '../../../api/workflow/workflow'
import { workflowModule, globalModule } from '../../../store/moduleName'
import { formatDateTime, dateToYyyyMmDd } from '../../../utils/datetimeUtil'

export default {
  components: {
    SSearchStaff,
    SDatePicker
  },
  props: {
    mode: {
      type: String,
      required: true,
      validator: function (value) {
        // The value must match one of these strings
        return ['new', 'edit'].indexOf(value) !== -1
      }
    },
    index: {
      type: Number,
      required: true
    },
    staff: {
      type: Object,
      default: null
    },
    masterEuid: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      mStaff: null,
      name: null,
      euid: null,
      startDate: null,
      endDate: null
    }
  },
  computed: {
    title: function () {
      if (this.mode === 'new') {
        return this.$t('PublicServant.Action.New')
      } else {
        return 'Edit Item'
      }
    }
  },
  watch: {
    staff: {
      handler: function (val) {
        // this.mStaff = Object.assign({}, val)
        // console.log(this.mStaff)
        if (val) {
          this.euid = val.euid
          this.name = val.name
          this.startDate = val.startDate
          this.endDate = val.endDate
        } else {
          this.euid = null
          this.name = null
          this.startDate = null
          this.endDate = null
        }
      },
      immediate: true
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },

    save () {
      let today = dateToYyyyMmDd(new Date())
      let body = {
        'endDate': formatDateTime(this.endDate),
        'startDate': formatDateTime(this.startDate),
        'followedByEuid': this.euid,
        'euid': this.masterEuid
      }
      if (this.endDate <= today) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('TaskList.AttentionManagement.EndDateInvalid'))
        return false
      }
      workflowApi.addStaffFollower(cb => {
        if (cb.status === 201 || cb.status === 200) {
          this.$store.dispatch(workflowModule + '/getStaffsAttentionMe', this.masterEuid)
        }
      }, body)
      this.close()
    }
  }
}
</script>
